/** The params of a notice that names a coefficient (kmod, γM) which hold coefficient values. */
export const COEFFICIENT_VALUE_PARAMS = ["value", "normative"] as const satisfies readonly (keyof NoticeParams)[];

/** Display-ready params of a lock calculator notice message (formatted by noticeText). */
export type NoticeParams = {
  distance: string;
  offset: string;
  cMin: string;
  min: string;
  classNumber: string;
  allowed: string;
  axis: string;
  missing: string;
  rejected: string;
  total: string;
  reason: string;
  member: string;
  rhoK: string;
  coefficient: string;
  value: string;
  normative: string;
  slot: string;
  /** Lateral resistance configurations before and after a rule changed it, shown by label. */
  fromConfig: string;
  toConfig: string;
  orientation: string;
  before: string;
  after: string;
  /** Labels of the buttons a message can name; `button` is the one that resolves the notice. */
  generateAll: string;
  generateFromData: string;
  generateManual: string;
  generateReport: string;
  reportTab: string;
  button: string;
};
